<template>
  <div class="popWrap">
    <h2>하위노드 추가</h2>
    <div class="cont">
      <input 
        ref="inputWrite"
        type="text" 
        placeholder="하위노드명을 입력하세요." 
        v-model="inputText" 
      >
    </div>
    <div class="btns">
      <btn-link :style="{minWidth: '60px'}" @click="clickCloseHandler">취소</btn-link>
      <btn-link color="blue" :style="{minWidth: '80px'}" @click="updateHandler">추가하기</btn-link>
    </div>
    <CloseBtn :closeHandler="clickCloseHandler" />
  </div>
</template>

<script>
import BtnLink from '@components/btns/BtnLink.vue'; 
import CloseBtn from '@components/btns/CloseBtn.vue'; 
export default {
  props : {
    openBln : Boolean , 
    // closeHandler : Function , 
    crntObj : Object , 
  } , 
  components : {
    BtnLink , 
    CloseBtn , 
  } , 
  data () {
    return {
      inputText : '' , 
    }
  } , 
  async mounted () {
  } , 
  watch : {
    'crntObj.obj.openBln' : {
      immediate : true , 
      handler ( bln ) {
        if ( bln ) {
          setTimeout(_=>{
            this.$refs.inputWrite.focus() ; 
          } , 350 ) ; 
        }
      } , 
    } , 
  } , 
  methods : {
    updateHandler () {
      if ( this.inputText == '' ) return ; 
      this.crntObj.updateHandler({ 
        type : this.crntObj.slotName , 
        text : this.inputText , 
        confirm : true , 
        openBln : false , 
      }) ; 
      this.inputText = '' ; 
      // contextMenu.vue -> 'crntObj.obj.confirm' 에서 변경을 감지한다.
    } , 
    clickCloseHandler ( e ) {
      e.preventDefault() ; 
      e.stopPropagation() ; 

      this.inputText = '' ; 
      this.crntObj.closeHandler() ; 
    } , 
  }
}
</script>

<style lang="scss" scoped>
.popWrap {
  display: flex; 
  flex-direction: column; 
  gap: 24px; 
  > h2 {
    height: 24px; 
    display: flex; 
    align-items: center; 
  }
  .cont {
    > input[type=text] {
      width: 400px; 
      height: 40px; 
      border: 1px solid $gray-9; 
      padding: 0 8px; 
      &::placeholder {
        color: $gray-d; 
      }
    }
  } // end of .cont 

  .btns {
    display: flex; 
    justify-content: center; 
    gap: 8px; 
  }
} // end of .popWrap 
</style>